module.exports = __webpack_public_path__ + "static/media/milk-payment-complete.543636ae.png";